/* eslint-disable no-unused-vars */
import moment from 'moment';
import React from 'react';

import { 
  Container, 
  IconContainer, 
  ContainerStatus,
  StatusName,
  SubtitleText
} from './styles';
import { RECEIPT_STEPS, RECEIPT_STEPS_TRANSKEY } from '../../../components/ReceiptDetailHistory/stepEnum';
import CheckCircleFilledIcon from '../../../../components/AllowanceRelease/icons/CheckCircleFilledIcon';
import CancelRoundedIcon from '../../../../components/AllowanceRelease/icons/CancelRounded';

function SingleStatus({
  changedStatusAt,
  vertical,
  user,
  justification,
  first,
  last,
  title,
}) {
  return (
    <Container vertical={vertical}>
      <IconContainer 
        first={!first} 
        last={!last} 
        vertical={vertical} 
        grayLine={true}
      >
        {RECEIPT_STEPS_TRANSKEY[RECEIPT_STEPS.INACTIVATED] === title ? 
          (
            <CancelRoundedIcon />
          ) : (
            <CheckCircleFilledIcon />
        )}
      </IconContainer>

      <ContainerStatus vertical={vertical}>
        <StatusName 
          activeStatus={vertical}
          vertical={vertical}
        >
          {title}
        </StatusName>
        {user && <SubtitleText upperStrong><strong>USUÁRIO:</strong> {user}</SubtitleText>}
        {justification && <SubtitleText upperStrong><strong>JUSTIFICATIVA:</strong> {justification}</SubtitleText>}

      
        <SubtitleText>
          {moment(changedStatusAt).format('DD/MM/YYYY HH:mm')}
        </SubtitleText>
      </ContainerStatus>
    </Container>
  );
}

export default SingleStatus;
